import Form from "./Form";
import useBeforeYouStart from "./hooks/useBeforeYouStart";

const BeforeYouStartForm: React.FC = () => {
  const props = useBeforeYouStart();
  return <Form {...props} />;
};

export default BeforeYouStartForm;
